import { Stack, styled, Typography } from '@mui/material';
import { CandidateProfileFormData } from 'features/profile/types';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import AllEmailsField from './AllEmailsField';
import PreferenceCheckboxes from './PreferenceCheckboxes';

interface FieldCommunicationPreferencesProps {
    /** Whether the candidate had a global email unsubscription at load time. */
    globallyUnsubscribed: boolean;
}

export default function FieldCommunicationPreferences({ globallyUnsubscribed }: FieldCommunicationPreferencesProps) {
    const { control } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');

    const isSubscribed = useWatch({ control, name: 'communicationPreferences.unspecified' });

    return (
        <Root>
            <Typography variant="caption"
                color="textSecondary"
            >
                { t('edit.sections.communicationPreferences.subtitle') }
            </Typography>

            { globallyUnsubscribed && <AllEmailsField /> }

            { /* Individual preferences stay locked until the candidate is (re)subscribed. */ }
            <PreferenceCheckboxes disabled={ !isSubscribed } />
        </Root>
    );
}

const Root = styled(Stack)(({ theme }) => ({
    gridColumn: '1 / -1',
    rowGap: theme.spacing(3)
}));
